import { API_CONFIG } from './api-configuration';

export const API_ENDPOINTS = {
  AUTH: {
    STATUS: `${API_CONFIG.BASE_URL}/auth/status`,
    TOKEN: `${API_CONFIG.BASE_URL}/auth/token`,
    SIGN_OUT: `${API_CONFIG.BASE_URL}/auth/sign-out`,
    EXCHANGE_CODE: `${API_CONFIG.BASE_URL}/auth/exchange-code`,
    SIGN_IN: `${API_CONFIG.SIGN_IN_URL}/sign-in`,
    PROFILE: `${API_CONFIG.SIGN_IN_URL}/profile`,
    SETTINGS: `${API_CONFIG.SIGN_IN_URL}/settings`,
  },
  VENDOR: {
    HOME: API_CONFIG.VENDOR_URL,
    BUSINESS_NEW: `${API_CONFIG.VENDOR_URL}/restaurant/new`,
  },
  CHAT: {
    NEW: API_CONFIG.CHAT_URL
  }
};